export default "__VITE_ASSET__511a7e3d__"